import "./LandholdingDetailsFields.css";

import { LANDHOLDING_REFERENCE_TYPE_OPTIONS } from "../../../constants";
import { ErrorBox } from "../../cards";
import { Select, TextInput } from "../../forms";
import { Column, Row } from "../../layout";
import { getErrorMessages, hasFieldError } from "../utils";
import { LandholdingDetailsFieldsProps } from "./models";

export const LandholdingDetailsFields = ({
  value,
  onChange,
  countryOptions = [],
  referenceOptions = LANDHOLDING_REFERENCE_TYPE_OPTIONS,
  corners = "default",
  errors,
  showGridReference = true,
  heading = "Landholding details",
  disabled = false,
}: LandholdingDetailsFieldsProps): JSX.Element => {
  return (
    <div className="LandholdingDetailsFields">
      {heading !== null && (
        <Row spacingV="ml">
          <Column span={12}>
            <h3>{heading}</h3>
          </Column>
        </Row>
      )}

      {errors && errors.length > 0 && (
        <Row spacingV="ml">
          <Column span={12}>
            <ErrorBox title="Please solve the below issues before continuing" text={getErrorMessages(errors)} />
          </Column>
        </Row>
      )}

      <Row spacingV="ml">
        <Column span={6}>
          <TextInput
            disabled={disabled}
            label="Landholding name"
            name="landholding-name"
            value={value.name}
            onChange={(name) => onChange({ ...value, name })}
            hasError={hasFieldError(errors, "Name")}
          />
        </Column>
        <Column span={6}>
          <Select
            disabled={disabled}
            label="Landholding reference"
            placeholder="Select"
            corners={corners}
            data={referenceOptions}
            value={value.reference}
            onChange={(reference) => onChange({ ...value, reference })}
            hasError={hasFieldError(errors, "ExternalParty")}
          />
        </Column>
      </Row>

      <Row spacingV="ml">
        <Column span={6}>
          <TextInput
            disabled={disabled}
            label="Landholding reference ID"
            name="landholding-reference-id"
            value={value.referenceId}
            onChange={(referenceId) => onChange({ ...value, referenceId })}
            hasError={hasFieldError(errors, "ExternalReference")}
          />
        </Column>
        <Column span={6}>
          <TextInput
            disabled={disabled}
            label="Region / County / State"
            name="landholding-region"
            value={value.region}
            onChange={(region) => onChange({ ...value, region })}
            hasError={hasFieldError(errors, "region")}
          />
        </Column>
      </Row>

      <Row spacingV="ml">
        <Column span={6}>
          <TextInput
            disabled={disabled}
            label="Latitude"
            name="landholding-latitude"
            optional
            value={value.latitude}
            onChange={(latitude) => onChange({ ...value, latitude })}
          />
        </Column>
        <Column span={6}>
          <TextInput
            disabled={disabled}
            label="Longitude"
            name="landholding-longitude"
            optional
            value={value.longitude}
            onChange={(longitude) => onChange({ ...value, longitude })}
          />
        </Column>
      </Row>

      <Row spacingV="ll">
        {showGridReference && (
          <Column span={6}>
            <TextInput
              disabled={disabled}
              label="Grid reference"
              name="landholding-grid-reference"
              optional
              value={value.gridReference}
              onChange={(gridReference) => onChange({ ...value, gridReference })}
            />
          </Column>
        )}
        <Column span={6}>
          <Select
            disabled={disabled}
            label="Country"
            placeholder="Select"
            corners={corners}
            data={countryOptions}
            value={value.countryCode}
            onChange={(countryCode) => onChange({ ...value, countryCode })}
          />
        </Column>
      </Row>
    </div>
  );
};
